import {StateChanges} from './stateChanges'
import {BlankState, BlankDictionary} from './stateParts'
import {StateSaver} from '@/js/localData'
import {RunStates} from './runStates'
import router from '../router'
import {firebaseStore} from 'shared/account/store/firebaseModule'
import {assignChosenStringAndLetterArray} from '../js/letterOperations'
import {stringWithoutMeteggedLetters} from 'shared/js/commonHebrew'
import conditionalOptions from 'shared/js/conditionalOptions'
import Vue from 'vue'

window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}

function applyWordChanges(state, newWordContainer) {
  let wordObj = state.allWorkingNikud.wordsArray[newWordContainer.index]
  // console.log('wordObj:')
  // console.log(wordObj)
  // console.log('newWordContainer:')
  // console.log(newWordContainer)
  Object.assign(wordObj, newWordContainer.changes)
  assignChosenStringAndLetterArray(wordObj, state)
}

const FIREBASE_KEY_BADCHARS = [".", "#", "$", "/", "[", "]", "\n"]

const prefixes = [
  {words: 'words', entry: 'entry', letters: 'letters'},
  {words: 'negativeWords', entry: 'negativeEntry', letters: 'negativeLetters'}
]

function nonDestructiveAssign(oldObj, newObj) { // no overwrite-erase prop props (or their props etc.) b/c missing
  Object.keys(newObj).forEach(k => { // in case user saved version without some new prop
    if (Object.prototype.hasOwnProperty.call(oldObj, k)) {
      if (oldObj[k] && typeof oldObj[k] === 'object' && !(Array.isArray(oldObj[k]))
          && newObj[k] && typeof newObj[k] === 'object' && !(Array.isArray(newObj[k]))) {
        nonDestructiveAssign(oldObj[k], newObj[k])
      } else oldObj[k] = newObj[k]
    }
  })
}

const basicMutations = {
  [StateChanges.BUILD_STATE] (state, commitObj) {
    // console.log('commitObj.contextData:')
    // console.log(JSON.stringify(commitObj.contextData))
    // console.log('commitObj.newStateJson')
    // console.log(commitObj.newStateJson)
    const newStateData = JSON.parse(commitObj.newStateJson)
    nonDestructiveAssign(state, newStateData)
    if (newStateData.allWorkingNikud) {
      const shouldRecalc = Array.isArray(newStateData.allWorkingNikud.wordsArray)
      if (shouldRecalc) { // simpler to recalc than to test (doing here b/c stateValidation currently does not CHANGE the stateToCommit - and doc data is always loaded here or in STORE_ALL_WORKING_NIKUD)
        state.allWorkingNikud.wordsArray.forEach((wordObj) => {
          assignChosenStringAndLetterArray(wordObj, state)
        })
      }
    }
  },
  [StateChanges.CONFIRM_FIRST_TIME_INITIALIZED] (state) {
    state.firstTimeInitialized = false
    StateSaver.saveState(state)
  },
  [StateChanges.NAKDAN_RUNNING] (state) {
    state.nakdanApiState = RunStates.RUNNING
  },
  [StateChanges.SET_NAKDAN_RESULTS]: function (state, responseData) {
    state.nakdanApiResponse = responseData
    state.nakdanApiState = RunStates.COMPLETE
    if (router.currentRoute.name !== 'nikud-edit') {
      state.allWorkingNikud.wordsArray = []
      state.currentPositionData.wordIndex = -1
      StateSaver.saveState(state)
      router.push({name: 'nikud-edit'})
    }
  },
  [StateChanges.NAKDAN_FAILED]: function (state) {
    state.nakdanApiState = RunStates.FAILED
  },
  [StateChanges.NAKDAN_TIMED_OUT]: function (state) {
    state.nakdanApiState = RunStates.TIMED_OUT
  },
  [StateChanges.GENRE_CLASSIFY_RUNNING] (state) {
    state.genreClassifyApiState = RunStates.RUNNING
  },
  [StateChanges.SET_GENRE_CLASSIFY_RESULTS]: function (state, responseData) {
    state.originalDocument.identifiedGenre = responseData.genre
    state.genreClassifyApiState = RunStates.COMPLETE
  },
  [StateChanges.GENRE_CLASSIFY_FAILED]: function (state) {
    state.genreClassifyApiState = RunStates.FAILED
  },
  [StateChanges.GENRE_CLASSIFY_TIMED_OUT]: function (state) {
    state.genreClassifyApiState = RunStates.TIMED_OUT
  },
  [StateChanges.LOAD_DOCUMENT_FILE]: function (state, documentFile) {
    state.originalDocument.source = documentFile;
    gtag("event", "load file", {
      'event_category': 'user input',
      'event_label': 'loaded file of type: ' + documentFile.type
    })
  },
  [StateChanges.EDIT_DOCUMENT_TEXT]: function (state, editedText) {
    state.originalDocument.text = editedText.text;
    if (editedText.nullifySource) state.originalDocument.source = null;
    if (state.originalDocument.text === '') state.originalDocument.id = BlankState.originalDocument.id
  },
  [StateChanges.SET_TEXT_FOR_NAKDAN_API_CALL]: function (state, newText) {
    state.forNakdanApiCall.text = newText
    if (newText) state.forNakdanApiCall.jsonData = null // because no more than ONE can be "truthy" at a time
    if (newText === state.originalDocument.text) state.originalDocument.id = Math.random()
  },
  [StateChanges.SET_JSON_DATA_FOR_NAKDAN_API_CALL]: function (state, newData) {
    state.forNakdanApiCall.jsonData = newData
    if (newData) state.forNakdanApiCall.text = '' // because no more than ONE can be "truthy" at a time
  },
  [StateChanges.STORE_ALL_PRE_SUBMISSION_OPTIONS]: function (state, options) {
    state.preSubmissionOptions = options;
  },
  [StateChanges.STORE_ALL_WORKING_NIKUD]: function (state, commitObj) {
    state.allWorkingNikud = JSON.parse(commitObj.newAllWorkingNikudJson)
    state.allWorkingNikud.id = state.originalDocument.id
    state['wordIdToIndexMap'] = {}
    state.allWorkingNikud.wordsArray.forEach((wordObj, i) => {
      state.wordIdToIndexMap[i] = i
      assignChosenStringAndLetterArray(wordObj, state)
    })
  },
  [StateChanges.REWRITE_WORD_IN_WORKING_ARRAY]: function (state, commitObj) {
    const wordsArray = state.allWorkingNikud.wordsArray
    const index = commitObj.newWordContainer.index
    const wordBefore = wordsArray[index].chosenWordString
    const wordBeforeIsOption0 = wordsArray[index].choiceType === 'option' 
                                && wordsArray[index].chosenOptionIndex === 0
    applyWordChanges(state, commitObj.newWordContainer)
    const userPermission = window.localStorage['permission-to-use-abbreviation-data'] // exists 
      && JSON.parse(window.localStorage['permission-to-use-abbreviation-data']) // i.e. the string is 'true'
    if (wordBeforeIsOption0) {
      const wordAfter = wordsArray[index].chosenWordString
      if (wordBefore !== wordAfter) gtag("event", "word rewritten", {
        'event_category': 'abbreviation expansion correction',
        'event_label': JSON.stringify({
          precedingWords: wordsArray.slice(Math.max(0, index - 5), index).map(w => w.chosenWordString),
          followingWords: wordsArray.slice(index, index + 5).map(w => w.chosenWordString),
          beforeChange: wordBefore,
          afterChange: wordAfter,
          userPermission: userPermission
        })
      })
    }
    if (commitObj.nextWordContainer) applyWordChanges(state, commitObj.nextWordContainer)
  },
  [StateChanges.REWRITE_WORD_TO_RUN_AND_POS_MAP]: function (state, newMap) {
    state.originalDocument.source.wordToRunAndPosMap = newMap
  },
  [StateChanges.SPLICE_WORDS_IN_WORKING_ARRAY]: function (state, commitObj) {
    state.allWorkingNikud.wordsArray.splice(
      commitObj.spliceWordsContainer.startIndex, commitObj.spliceWordsContainer.toDelete, ...(commitObj.spliceWordsContainer.spliceWordsArray))
    state.allWorkingNikud.lastWordId += commitObj.spliceWordsContainer.spliceWordsArray.length
    state.allWorkingNikud.wordsArray.forEach((wordObj, i) => {
      state.wordIdToIndexMap[wordObj.wordId] = i
      assignChosenStringAndLetterArray(wordObj, state)
    })
    if (commitObj.nextWordContainer) applyWordChanges(state, commitObj.nextWordContainer)
  },
  [StateChanges.SET_CURRENT_WORD_INDEX]: function (state, newIndex) {
    state.currentPositionData.wordIndex = newIndex;
  },
  [StateChanges.VALIDATION_FAILURE_POPUP_SHOWN]: function (state) {
    state.validationResult.popupShown = true;
  },
  [StateChanges.SET_CURRENT_LETTER_INDEX]: function (state, newIndex) {
    state.currentPositionData.letterIndex = newIndex;
  },
  [StateChanges.SET_WORD_AND_LETTER]: function (state, indicesObj) {
    state.currentPositionData.wordIndex = indicesObj.word
    state.currentPositionData.letterIndex = indicesObj.letter
  },
  [StateChanges.SET_SHOW_AIMS]: function (state, newShowAims) {
    state.postSubmissionOptions.showAims = newShowAims;
  },
  [StateChanges.SET_DISABLE_GO_HOME_PROMPT]: function (state, newDisableGoHomePrompt) {
    state.postSubmissionOptions.disableGoHomePrompt = newDisableGoHomePrompt;
  },
  [StateChanges.SET_DISABLE_BACK_TO_TEXT_PREP_PROMPT]: function (state, newDisableBackToTextPrepPrompt) {
    state.postSubmissionOptions.disableBackToTextPrepPrompt = newDisableBackToTextPrepPrompt;
  },
  [StateChanges.SET_DISABLE_SWITCH_GENRE_PROMPT]: function (state, newDisableSwitchGenrePrompt) {
    state.postSubmissionOptions.disableSwitchGenrePrompt = newDisableSwitchGenrePrompt;
  },
  [StateChanges.SET_ALL_POST_SUBMISSION_OPTIONS]: function (state, newPostSubmissionOptions) {
    state.postSubmissionOptions = Object.assign({}, newPostSubmissionOptions);
  },
  [StateChanges.UPDATE_USER_DICTIONARY] (state, commitObj) {
    if (commitObj.justEmptyLocalCopy) {
      Object.keys(BlankDictionary).forEach(k => {
        Vue.set(state.account.sync.dictionary, k, BlankDictionary[k])
      })
      return
    }
    var dictionaryToSave = commitObj.newUserDictionaryJson ? JSON.parse(commitObj.newUserDictionaryJson)
                                                           : JSON.parse(JSON.stringify(state.account.sync.dictionary))
    var keepPinned = []
    prefixes.forEach(prefix => {
      if (commitObj[prefix.words + 'ToDelete']) commitObj[prefix.words + 'ToDelete'].forEach(dictString => {
        if (dictionaryToSave[prefix.entry + 'Present'][dictString] === 'pinned') keepPinned.push(dictString)
        delete dictionaryToSave[prefix.entry + 'Present'][dictString]
        const withoutMeteggedLetters = stringWithoutMeteggedLetters(
          conditionalOptions.optionObjFromDictString(dictString).displayText)
        var lettersMap = dictionaryToSave[prefix.letters + 'Map'][withoutMeteggedLetters]
        lettersMap.splice(lettersMap.indexOf(dictString), 1)
      }) // note: "delete"s need to be BEFORE "add"s [for NikudOptionsPane.moveShownOptionToTop()]
      if (commitObj[prefix.words + 'ToAdd']) commitObj[prefix.words + 'ToAdd'].forEach(dictString => {
        if (FIREBASE_KEY_BADCHARS.every(badChar => !(dictString.includes(badChar)))) {
          dictionaryToSave[prefix.entry + 'Present'][dictString]
                                = keepPinned.includes(dictString) ? 'pinned' : true
          const withoutMeteggedLetters = stringWithoutMeteggedLetters(
            conditionalOptions.optionObjFromDictString(dictString).displayText)
          if (dictionaryToSave[prefix.letters + 'Map'][withoutMeteggedLetters]) {
            dictionaryToSave[prefix.letters + 'Map'][withoutMeteggedLetters].unshift(dictString)
          } else dictionaryToSave[prefix.letters + 'Map'][withoutMeteggedLetters] = [dictString]
        } // else console.log('word with bad character cannot be added to user dictionary: ' + JSON.stringify(dictString))
      })
      if (commitObj.toChangeWhetherPinned) {
        if (commitObj.toChangeWhetherPinned.newValueOfWhetherPinned) {
          const withoutMeteggedLetters = stringWithoutMeteggedLetters(
            conditionalOptions.optionObjFromDictString(commitObj.toChangeWhetherPinned.dictString).displayText)
            dictionaryToSave.lettersMap[withoutMeteggedLetters].forEach(dictString => {
              dictionaryToSave.entryPresent[dictString] = true // i.e. only ONE can be pinned, so first unpin
          })
        }
        dictionaryToSave.entryPresent[commitObj.toChangeWhetherPinned.dictString] 
          = commitObj.toChangeWhetherPinned.newValueOfWhetherPinned ? 'pinned' : true
      }
    })
    firebaseStore('dictionary', 
      Object.keys(dictionaryToSave.entryPresent)
        .concat(Object.keys(dictionaryToSave.negativeEntryPresent)).length 
          ? dictionaryToSave : null)
  },
  [StateChanges.SET_DISABLE_UPLOAD_DICTIONARY_PROMPT]: function (state, newDisableUploadDictionaryPrompt) {
    state.postSubmissionOptions.disableUploadDictionaryPrompt = newDisableUploadDictionaryPrompt;
  },
  [StateChanges.SET_SHOW_NIKUD_BUTTONS]: function (state, newShowButtons) {
    state.postSubmissionOptions.showNikudButtons = newShowButtons;
  },
  [StateChanges.SET_NIKUD_KEYBOARD]: function (state, newNikudKeyboard) {
    state.postSubmissionOptions.nikudKeyboard = newNikudKeyboard;
  },
  'emptyState': function (state) {
    Object.assign(state, JSON.parse(JSON.stringify(BlankState)), { firstTimeInitialized: false })
  }
}

export default basicMutations
